import { icon, Icon } from '../lib/fa-icons.js';
import Widget from "./base.js";
import { NewsletterInTOCBig } from './newsletter-in-toc-big.js';

function watchScrollForToTop() {
	const tocEl = document.querySelector('.TableOfContentsBig');
	const toTopBtn = document.querySelector('.js_to-top');
	if (!tocEl || !toTopBtn) return;

	let ticking = false;
	const scrollWatch = () => {
		if (ticking) return;
		ticking = true;
		setTimeout(() => {
			const tocBottom = tocEl.getBoundingClientRect().bottom;
			if (tocBottom < 0) {
				toTopBtn.classList.remove('--hidden');
			} else {
				toTopBtn.classList.add('--hidden');
			}
			ticking = false;
		}, 500);
	};

	window.addEventListener('scroll', scrollWatch, { passive: true });
	scrollWatch();
}


export class TableOfContentsBig extends Widget {
	componentWillMount() {
		this.state.tocId = `toc-${Math.random().toString(36).substr(2, 9)}`;
		this.state.expand = false;
		this.toggleCollapsed = this.toggleCollapsed.bind(this);
	}

	componentDidMount() {
		if (this.props.enable) {
			const h2s = document.querySelectorAll(".js_article-content h2");
			if (h2s.length > 0) {
				// Convert NodeList to Array for mapping
				const toc = Array.from(h2s).map((h2) => {
					if (h2.id) {
						let anchorId = h2.id;
						if (h2.parentElement.classList.contains("tpm-minipost-container")) {
							anchorId = h2.parentElement.id;
						}
						return {
							title: h2.innerText,
							id: h2.id,
							anchorId: anchorId,
						}
					};
				});
				
				// Filter out any undefined entries (in case some h2s didn't have ids)
				const filteredToc = toc.filter(item => item !== undefined);

				//loop over h2's and find their associated label and author, if any exists
				const expandedToc = filteredToc.map((item) => {
					const h2 = document.getElementById(item.id);
					const parent = h2.parentElement;
					if (!parent.classList.contains("tpm-minipost-container")) return item;

					const label = parent.querySelector(".tpm-minipost-labels");

					if (label && label.classList.contains("tpm-minipost-labels")) {
						label.querySelectorAll(".tpm-minipost-label").forEach((label) => {
							const labelText = label.innerText.trim();
							if (labelText) {
								item.label = labelText;
							}
						});
					}

					const author = parent.querySelector(".tpm-minipost-author:not(.hidden)");
					if (author) {
						item.author = author.innerText.trim();
						//remove the "By " prefix if it exists
						if (item.author.startsWith("By ")) {
							item.author = item.author.substring(3);
						}
					}

					return item;
				});



				this.setState({
					ready: true,
					toc: expandedToc,
				}, ()=>{
					// move totop button
					const toTopButton = document.querySelector(".js_to-top");
					if(toTopButton) {
						document.querySelector(".Primary").prepend(toTopButton);
						watchScrollForToTop();
					}

					//position the toc below the first heading if we're on the right and 
					if (this.props.cssclasses && this.props.cssclasses.includes('--right') && window.innerWidth > 1280) {	
						const firstHeading = document.querySelector('.Article__Content h2');
						const parent = firstHeading.parentElement;
						const distance = firstHeading.getBoundingClientRect().bottom - parent.getBoundingClientRect().top;
						document.querySelector('.TableOfContentsBig').style.top = `${distance + 15}px`;
					}


					//if height of .TableOfContentsBig is greater than half the viewport height, enable collapse
					const tocEl = document.querySelector('.TableOfContentsBig');
					if (tocEl.getBoundingClientRect().height > window.innerHeight / 2) {
						this.setState({canCollapse: true, collapsed: true});
					}
				});
			}	
		}
	}

	componentDidUpdate() {
	}

	toggleCollapsed() {
		this.setState({collapsed: !this.state.collapsed});
	}

	renderList() {
		return (
			<ul class="TableOfContentsBig__List" id={`TableOfContentsBig__List ${this.state.canCollapse ? '--can-collapse' : ''}`}>
				{this.state.toc.map((item, index) => {
					if (this.state.canCollapse && this.state.collapsed && index >= 3) return null;
					return (<li class={`TableOfContentsBig__Item ${item.label ? '--has-label' : ''} ${item.author ? '--has-author' : ''}`} key={item.id}>
						<div class="TableOfContentsBig__ItemLeft">
							<div class="TableOfContentsBig__ItemLabel"><span>{item.label}</span></div>
							<a class="TableOfContentsBig__ItemTitle" href={`#${item.anchorId}`}>{item.title}</a>
						</div>
						{item.author && (
							<div class="TableOfContentsBig__ItemRight">
								{item.author}
							</div>
						)}
					</li>);
			})}
				{this.state.canCollapse && this.state.collapsed && (
					<div className="TableOfContentsBig__ListToggle" onClick={this.toggleCollapsed}>SHOW ({this.state.toc.length - 3}) MORE</div>
				)}

				{this.state.canCollapse && !this.state.collapsed && (
					<div  className="TableOfContentsBig__ListToggle" onClick={this.toggleCollapsed}>HIDE ({this.state.toc.length - 3})</div>
				)}
			</ul>
		);
	}


	renderContent() {
		if (!this.state.toc) return;

		return (
			<div className="TableOfContentsBig__Inner" id={this.state.tocId}>
				<a className={`TableOfContentsBig__ToTop --hidden js_to-top`} href={`#${this.state.tocId}`}><Icon name="list-ul" style="light" /></a>
				<div className="TableOfContentsBig__Head">
					<Icon name="list-ul" style="light" />
					<span className="TableOfContentsBig__HeadText">In This Issue</span>
					<div className="TableOfContentsBig__HeadSubscribe">
						<NewsletterInTOCBig category={this.props.category} cssClasses="center" />
					</div>
				</div>
				{this.renderList()}
				
				
			</div>
		);
	}
}
